import React, { createContext, useCallback, useContext, useState } from "react";

/**
 * PageMetaContext lets pages push dynamic metadata (actions, custom title)
 * up to the TopBar without prop-drilling.
 *
 * Usage in a page:
 *   const { setPageMeta } = usePageMeta();
 *   useEffect(() => {
 *     setPageMeta({ actions: <Button>Create</Button> });
 *     return () => setPageMeta({});
 *   }, [setPageMeta]);
 */
const PageMetaContext = createContext({
  pageMeta: {},
  setPageMeta: () => {},
});

export function PageMetaProvider({ children }) {
  const [pageMeta, setPageMetaState] = useState({});

  const setPageMeta = useCallback((meta) => {
    setPageMetaState(meta);
  }, []);

  return (
    <PageMetaContext.Provider value={{ pageMeta, setPageMeta }}>
      {children}
    </PageMetaContext.Provider>
  );
}

export function usePageMeta() {
  return useContext(PageMetaContext);
}
